
import React from "react";
// import { Suspense, lazy } from 'react';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import CareerCounselling from "../Components/Dashboard/CareerCounselling";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'

// const CareerCounselling = lazy(() => import('../Components/Dashboard/CareerCounselling'));
const AuthCareercounselling = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <CareerCounselling /> : <SessionTimeoutRedirect />
}
export default AuthCareercounselling;


